import { createContext } from "preact";
import { useContext } from "preact/hooks";
import { MobileDashboardState } from "./interfaces";

const context = createContext<MobileDashboardState | null>(null);

export const MobileDashboardProvider = context.Provider;

export const useMobileDashboard = () => {
    const state = useContext(context);

    if (!state) {
        throw new Error("This hook should be used inside dashboard page");
    }

    return state;
};
